import React, { useState, useEffect } from "react";
import "./style.css";
import { getBatchList } from "../../../services/batch.service";
import Pageloader from "../../../components/loader";
import { Typography, Button } from "antd";
import { validationErrors } from "../../../utils/Helpers";
import { useNavigate } from "react-router-dom";

const { Text, Title } = Typography;

const BatchRiderManagement = () => {
  const pagename = "Batch Rider";
  const navigate = useNavigate();
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    postLists();
  }, []);
  const postLists = async () => {
    try {
      // setLoading(true);
      const resp = await getBatchList();
      // console.log("postLists", resp);
      setPostData(resp.data.data);
    } catch (error) {
      // setErrMsg("Something went wrong");
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const postColumns = [
    {
      title: "User",
      dataIndex: "id",
    },
    {
      title: "Rider ID",
      render: (batch) => <Text>{batch.batchLevel}</Text>,
      dataIndex: "batch",
    },
    {
      title: "Rider Name",
      render: (batch) => <Text>{batch.batchLevel}</Text>,
      dataIndex: "batch",
    },
    {
      title: "Status",
      render: (batch) => (
        <Text type={batch.batchLevel == 1 ? "danger" : "success"}>
          {batch.batchLevel}
        </Text>
      ),
      dataIndex: "batch",
    },
    {
      title: "Reason",
      render: (batch) => <Text>{batch.batchLevel}</Text>,
      dataIndex: "batch",
    },
    {
      title: "Last Batch",
      render: (batch) => <Text>{batch.batchLevel}</Text>,
      dataIndex: "batch",
    },
    {
      title: "New Batch",
      render: (batch) => <Text>{batch.batchLevel}</Text>,
      dataIndex: "batch",
    },
    {
      title: "Date",
      render: (slotsVal) => <Text>{slotsVal} %</Text>,
      dataIndex: "slotsPercentage",
    },
  ];

  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>{pagename} Management</Title>
        </div>
        <div className="pch">
          <Button onClick={() => navigate("/batch/bulkbatchrider")}>
            {pagename} Bulk Upload
          </Button>
        </div>
      </div>
      {/* {loading ? (
        <Pageloader />
      ) : (
        <div className="p-content">
          <Table dataSource={postData} columns={postColumns} />
        </div>
      )} */}
    </div>
  );
};
export default BatchRiderManagement;
